import React, { useContext, useEffect, useRef, useState } from 'react'
import axios from 'axios'
import { baseUrl, dataContext, portal } from '../../../App'
import { useElapsedTime } from 'use-elapsed-time'
import { colorCleanUp, secondsToMS, translateToBanglaNum } from './questionHelper'
import activityLogSubmission from '../../../helper/activitylog'
import { useNavigate } from 'react-router-dom';
import SpellingGamePlay from './SpellingGamePlay/SpellingGamePlay'
import PopUpMenu from '../PopUpMenu/PopUpMenu'
import rightAudio from '../../../assets/sound/right.wav'
import wrongAudio from '../../../assets/sound/wrong2.mp3'
import timesUpAudio from '../../../assets/sound/timesUp.mp3'
import timerAudio from '../../../assets/sound/timer.mp3'


const QuestionBodySpelling = ({ eventDetails, finalScore, setFinalScore, setShowResultModal, playerRound }) => {
  const { token, setToken, playerData, setPlayerData, events, setEvents } = useContext(dataContext);
  const [allQuestions, setAllQuestions] = useState([])
  const [currentQues, setCurrentQues] = useState({})
  const [currentQuesIndex, setCurrentQuesIndex] = useState(null)
  const [isLoadingEnd, setIsLoadingEnd] = useState(false)
  const [timerWidth, setTimerWidth] = useState(100)
  const [timerTime, setTimerTime] = useState(eventDetails.allocated_time)
  const [isPlaying, setIsPlaying] = useState(false);
  const [showPopUp, setShowPopUp] = useState(false);
  const { elapsedTime } = useElapsedTime({ isPlaying });
  const navigate = useNavigate();

  const totalClicks = useRef(0); // every hive letter tapped this round
  const totalWordLength = useRef(0); // letters across every word found this round
  const wordsFound = useRef(0);

  const tickingElm = useRef(0);
  useEffect(() => {
    axios.get(`${baseUrl}/api/questions/?rules=${eventDetails.id}&portal=${portal}`, {
      headers: { Authorization: `Token ${token}` }
    })
      .then(response => {
        setAllQuestions(response.data)
        console.log(response.data)
        setIsLoadingEnd(true)
        setCurrentQuesIndex(0)
        tickingElm.current = new Audio(timerAudio)
        tickingElm.current.volume = 0.5;
        tickingElm.current.play()
        tickingElm.current.loop = true;
        submitProgressRecord(response.data.map(q => q.id));
      })
  }, [])

  let remainingWidth = (((timerTime - elapsedTime) / timerTime) * 100).toFixed(2);
  let remainingTime = (((timerTime - elapsedTime))).toFixed(2);

  useEffect(() => {
    setTimerWidth(remainingWidth)
  }, [remainingWidth])

  if (elapsedTime > timerTime) {
    if (isPlaying) {
      setIsPlaying(false)
      gameDone()
    }
  }



  useEffect(() => {
    let msisdn = null;
    if (playerData?.id) {
      msisdn = playerData?.msisdn;
    }
    activityLogSubmission(`events-${eventDetails.id}`, msisdn);
    return () => {
      // cleanup function
      console.log("in cleanup")
    }
  }, [])

  // Loading: [Done]
  useEffect(() => {
    if (isLoadingEnd) {
      console.log(currentQues)
      if(allQuestions.length <= 0){
        navigate('../',{replace:true})
      }else{
        setIsPlaying(true)
      }
    }
  }, [currentQuesIndex])



  function gameDone() {
    submitFinalScore()
    sessionStorage.setItem('quizPlay_eventId', eventDetails.id);
    sessionStorage.setItem('quizPlay_passingScore', eventDetails.passing_score);
    setIsPlaying(false)
    setShowResultModal(true)
    navigate(`../?page=result&eventId=${eventDetails.id}`)
  }
  useEffect(() => {
    return () => {
      tickingElm.current.pause()
      console.log("in cleanup")
    }
  }, [])

  function submitProgressRecord(roundQuestions) {
    axios.post(`${baseUrl}/api/participant/quizplay_record`, {
      msisdn: playerData?.msisdn,
      category: null,
      time_taken: Math.floor(elapsedTime),
      round_number: playerRound + 1,
      event: eventDetails.id,
      right_count: Number(sessionStorage.getItem('quizPlay_totalRightScore')) || 0,
      question_count: 1,
      serviceType: "SpellingBee",
      portal: 18,
      round_questions: roundQuestions
    }, {
      headers: { Authorization: `Token ${token}` }
    });
  }

  function recordFoundWord(word) {
    totalWordLength.current += word.length;
    wordsFound.current += 1;
    if (wordsFound.current % 5 === 0) {
      submitProgressRecord(`${totalWordLength.current}_${totalClicks.current}`);
    }
  }

  function submitFinalScore(){
    let lastActiveTime = localStorage.getItem('quizPlay_lastActiveTime');
    let totalTimeTakenLocalStorage = 0;
    if (lastActiveTime) {
      totalTimeTakenLocalStorage = Math.floor((Date.now() - parseInt(lastActiveTime, 10)) / 1000);
    }
    let finalTimeTaken = Math.min(Math.max(totalTimeTakenLocalStorage, Math.floor(elapsedTime)), 180)
    if(finalTimeTaken === 0 )return;
    axios.post(`${baseUrl}/api/participant/quizplay_summery_submission`, {
      msisdn: playerData?.msisdn,
      category: null,
      time_taken: finalTimeTaken,
      round_number: playerRound + 1,
      event: 134,
      right_count: parseInt(sessionStorage.getItem('quizPlay_totalRightScore')),
      question_count: parseInt(sessionStorage.getItem('quizPlay_totalWrongScore')) + parseInt(sessionStorage.getItem('quizPlay_totalRightScore')),
      serviceType: "SpellingBee",
      portal: 18,
      round_questions: `${totalWordLength.current}_${totalClicks.current}`
    }, {
      headers: { Authorization: `Token ${token}` }
    });
    localStorage.removeItem('quizPlay_lastActiveTime');
  }

  function insertData(isRight, mobile, round, questionId, selectedAns, category, eventId) {
    // insert Data Function
    console.log(isRight, mobile, round, questionId, selectedAns, category, eventId)
    // axios.post(`${baseUrl}/api/participant/`, {
    //   is_right: isRight,
    //   msisdn: mobile,
    //   round_number: round,
    //   question: questionId,
    //   selected_answer: selectedAns,
    //   category: category,
    //   event: eventId,
    //   portal: portal
    // }, {
    //   headers: { Authorization: `Token ${token}` }
    // });
  }
  return (
    <>
      {/* {allQuestions?.length && <MixUp props={{ insertData, playerData, playerRound, eventDetails, setFinalScore, setShowResultModal, gameDone,allQuestions,remainingTime,timerWidth }} />} */}
      {/* <>Hello from spelling</> */}
      {(allQuestions?.length > 0) && <SpellingGamePlay props={{ insertData, playerData, playerRound, eventDetails, setFinalScore, setShowResultModal, gameDone,allQuestions,remainingTime,timerWidth,setShowPopUp,rightAudio,wrongAudio,wrongAudio, recordFoundWord, onLetterClick: () => { totalClicks.current += 1; } }} />}
      {showPopUp && <PopUpMenu setShowPopUp={setShowPopUp} eventDetails={eventDetails} />}
    </>
  )
}

export default QuestionBodySpelling